<div class="auc_list_shame" id="auc_list_shame_9">
  <img src="/assets/images/auctions/{{ lang }}/BAYAUC.png" class="shame_img" alt="BAYAUC">
  <div
    class="shame_blocks shame_block_1"
    nz-tooltip
    nzTooltipTitle="{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.LOT_NUM' | translate }}"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  ></div>
  <div
    class="shame_blocks shame_block_2"
    nz-tooltip
    [nzTooltipTitle]="shameblock2"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  >
    <ng-template #shameblock2>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.VEHICLE_PARAMS' | translate }}
      </div>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.CAR_NAME' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.MODEL_VERSION' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.ENGINE_CAPACITY' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.CHASSIS_MODIFICATION' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.DOORS' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.TRANSMISSION' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.VEHICLE_COLOR' | translate }}</p>
    </ng-template>
  </div>
  <div
    class="shame_blocks shame_block_3"
    nz-tooltip
    [nzTooltipTitle]="shameblock3"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  >
    <ng-template #shameblock3>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.VEHICLE_PARAMS' | translate }}
      </div>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.FIRST_REG_DATE' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.MILEAGE' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.DRIVETRAIN_TYPE' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.SEATS' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.FUEL_TYPE.TITLE' | translate }}</p>
      <p>{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.RECYCLE_TICKET' | translate }}</p>
    </ng-template>
  </div>
  <div
    class="shame_blocks shame_block_4"
    nz-tooltip
    nzTooltipTitle="{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.GRADE' | translate }}"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  ></div>
  <div
    class="shame_blocks shame_block_5"
    nz-tooltip
    nzTooltipTitle="{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.INTERIOR_GRADE' | translate }}"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  ></div>
  <div
    class="shame_blocks shame_block_6"
    nz-tooltip
    nzTooltipTitle="{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.EXTERIOR_GRADE' | translate }}"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  ></div>
  <div
    class="shame_blocks shame_block_7"
    nz-tooltip
    [nzTooltipTitle]="shameblock7"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  >
    <ng-template #shameblock7>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.ORIGINAL_EQUIPMENT' | translate }}
      </div>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.VEHICLE_DIMENSIONS' | translate }}
      </div>
    </ng-template>
  </div>
  <div
    class="shame_blocks shame_block_8"
    nz-tooltip
    [nzTooltipTitle]="shameblock8"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  >
    <ng-template #shameblock8>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.TECH_INSP' | translate }}
      </div>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.CAR_HISTORY' | translate }}
      </div>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.CHASSIS_NUM' | translate }}
      </div>
    </ng-template>
  </div>
  <div
    class="shame_blocks shame_block_9"
    nz-tooltip
    [nzTooltipTitle]="shameblock9"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  >
    <ng-template #shameblock9>
      <div class="header">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.DAMAGE_SCHEME.TITLE' | translate }}
      </div>
      <p>
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.DAMAGE_SCHEME.DESCR' | translate }}
        <a href="https://ecarjp.com/article/sheet" target="_blank">
          {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.DAMAGE_SCHEME.LINK' | translate }}
        </a>
      </p>
    </ng-template>
  </div>
  <div
    class="shame_blocks shame_block_10"
    nz-tooltip
    nzTooltipTitle="{{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.INSPECTOR_NOTES' | translate }}"
    nzTooltipPlacement="top"
    [nzTooltipOverlayClassName]="'auction-tip-block-tooltip'"
  ></div>
</div>
